import React from 'react';
import { Button, Col, Row } from 'reactstrap';
import './styles.css';

interface PreviewsWebCamProps {
  base64: string | null;
  takeOffAgain: () => void;
  selfie?: boolean;
}

const PreviewsWebCam: React.FC<PreviewsWebCamProps> = ({
  base64,
  takeOffAgain,
  selfie = false,
}) => {
  const handleTakeOffAgain = () => {
    takeOffAgain();
  };

  return (
    <>
      <Row className="mb-2">
        <Col sm="12" className="text-center">
          <div
            style={{
              width: '100%',
              height: 300,
              boxSizing: 'border-box',
            }}
          >
            <div
              style={{
                width: '100%',
                height: '100%',
                backgroundImage: `url(${base64})`,
                backgroundSize: 'contain',
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
                WebkitBackgroundSize: 'contain',
                ...(selfie
                  ? {
                      WebkitTransform: 'scaleX(-1)',
                      transform: 'scaleX(-1)',
                    }
                  : {}),
              }}
            />
            {/* <img src={base64 ?? ''} alt="img" className="img-previwes" /> */}
          </div>
        </Col>
      </Row>

      <Row className="mb-2">
        <Col className="text-center">
          <h2 className="text-primary">O foto está nítida?</h2>
          <p>Verifique se o documento está nítido.</p>
          <Button onClick={() => handleTakeOffAgain()} color="warning">
            Tirar novamente
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default PreviewsWebCam;
